import { useCallback, useMemo, useState } from 'react';
import { appsData } from '../data/appsData';

const readIds = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || '[]');
  } catch {
    return [];
  }
};

export function useToolPreferences() {
  const [favouriteIds, setFavouriteIds] = useState(() =>
    readIds('vicinity-favourites')
  );
  const [recentIds, setRecentIds] = useState(() =>
    readIds('vicinity-recent-tools')
  );
  const [compact, setCompact] = useState(
    () => localStorage.getItem('vicinity-view') === 'compact'
  );

  const toggleFavourite = useCallback((id) => {
    setFavouriteIds((current) => {
      const updated = current.includes(id)
        ? current.filter((itemId) => itemId !== id)
        : [...current, id];
      localStorage.setItem('vicinity-favourites', JSON.stringify(updated));
      return updated;
    });
  }, []);

  const recordOpen = useCallback((id) => {
    setRecentIds((current) => {
      const updated = [id, ...current.filter((itemId) => itemId !== id)].slice(0, 4);
      localStorage.setItem('vicinity-recent-tools', JSON.stringify(updated));
      return updated;
    });
  }, []);

  const toggleCompact = useCallback(() => {
    setCompact((current) => {
      localStorage.setItem('vicinity-view', current ? 'grid' : 'compact');
      return !current;
    });
  }, []);

  const favourites = useMemo(
    () => favouriteIds.map((id) => appsData.find((app) => app.id === id)).filter(Boolean),
    [favouriteIds]
  );
  const recent = useMemo(
    () => recentIds.map((id) => appsData.find((app) => app.id === id)).filter(Boolean),
    [recentIds]
  );

  return {
    favouriteIds,
    favourites,
    recent,
    compact,
    toggleFavourite,
    recordOpen,
    toggleCompact,
  };
}